import { render } from "./User.vue?vue&type=template&id=25810bea&scoped=true&bindings={\"goBack\":\"setup\",\"goTo\":\"setup\"}"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=25810bea&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-25810bea"

export default script